/**
 * A failed write has nothing to patch, and its rejection already reaches the
 * caller through the mutation's own promise, so it is swallowed here. A throw
 * from `patch` is a cache bug and propagates.
 */
export const settleWrite = async <T>(
  queryFulfilled: Promise<{ data: T }>,
  patch: (data: T) => void,
): Promise<void> => {
  let data: T;
  try {
    ({ data } = await queryFulfilled);
  } catch {
    return;
  }
  patch(data);
};
